interface SunnyIconProps {
  className?: string;
}

export const SunnyIcon = ({ className = "w-8 h-8" }: SunnyIconProps) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Sun rays */}
      <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
      </g>

      {/* Sun circle */}
      <circle cx="12" cy="12" r="5" fill="currentColor" />

      {/* Weather station antenna */}
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
        <line x1="12" y1="17" x2="12" y2="20" />
        <circle cx="12" cy="20.5" r="0.5" fill="currentColor" />
      </g>
    </svg>
  );
};
